import { Component, OnInit, Inject } from '@angular/core';
import { Agreement } from '../../models/agreement.model';
import { AgreementResponse } from '../../models/agreement-response.model';
import { EDeliveryService } from '../../services/edelivery.service';
import { AgreementService } from '../../services/agreement.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationComponent } from '../confirmationDialog/confirmation.component';
import { PershingError } from '@pershing/pershing-core';
import { Subscription, combineLatest, BehaviorSubject, Observable } from 'rxjs';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
  selector: 'agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css']
})
export class AgreementComponent implements OnInit {

  agreementResponse: AgreementResponse = null;
  agreement: Agreement = null;
  error$: Observable<PershingError>;
  private agreementSubscription: Subscription;
  private combinedSubscription: Subscription;
  private _error: BehaviorSubject<PershingError>;
  displayBackToEnrollment: boolean = false;
  updatePreferencesInProgressFlag: boolean = false;
  oneClickEnrollFlag: boolean = false;

  // Labels
  edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;
  backToEnrollmentLabel: any = EdeliveryLabels.BACK_TO_ENROLLMENT;
  agreeLabel: any = EdeliveryLabels.AGREE_LABEL;
  disagreeLabel: any = EdeliveryLabels.DISAGREE_LABEL;
  cancelLabel = EdeliveryLabels.CANCEL;

  constructor(private eDeliveryService: EDeliveryService, private agreementService: AgreementService, private dialogRef: MatDialogRef<AgreementComponent>,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private translate: PershingTranslationService) {
                this._error = new BehaviorSubject<PershingError>(null);
                this.error$ = this._error.asObservable();
                if (this.translate) {
                  this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
                }
                if (data) {
                  this.oneClickEnrollFlag = data;
                }
              }

  ngOnInit() {
    this.agreementSubscription = this.agreementService.agreementResponse$.subscribe(response => {
      if (response !== undefined && response !== null) {
        this.agreementResponse = response;
        this.agreement = this.agreementResponse.response;
      }
    });
    this.agreementService.retrieveAgreement();
    if (this.agreementService.enableBackToEnrollment) {
      this.displayBackToEnrollment = true;
    }
  }

  ngOnDestroy() {
    console.log('destroying agreement component');
    if (this.agreementSubscription) {
      this.agreementSubscription.unsubscribe();
    }
    if (this.combinedSubscription) {
      this.combinedSubscription.unsubscribe();
    }
    this.agreementService.enableBackToEnrollment = false;
  }

  backButton() {
    if (this.oneClickEnrollFlag) {
      this.dialogRef.close();
    } else {
      this.agreementService.enableBackToEnrollment = false;
      this.eDeliveryService.backButton();
    }
  }

  close() {
    this.eDeliveryService.triggerRefresh();
    this.dialogRef.close();
  }

  submitPreferences() {
    if (!this.updatePreferencesInProgressFlag) {
      this.updatePreferencesInProgressFlag = true;
    } else {
      return;
    }
    let tempAgreement = this.agreement;
    tempAgreement.agreedFlag = true;
    this.agreementService.updateAgreement(tempAgreement);
    this.eDeliveryService.submitPreferences();

    this.combinedSubscription = combineLatest(this.eDeliveryService.confirmationResponse$, this.agreementService.agreementResponse$)
      .subscribe(([confirmResponse, agreeResponse]) => {
        console.log('confirmResponse: ', confirmResponse, 'agreeResponse: ', agreeResponse);
        if (confirmResponse.accounts !== undefined && agreeResponse.response !== undefined) {
          // Reset final list and account map so that there is no previous data stored.
          this.eDeliveryService.finalListOfAccounts = [];
          this.eDeliveryService.accountsMap.clear();
          this.eDeliveryService.accountsWithChangedEmails = [];
          this.eDeliveryService.disableEnrollButtonInEdit(true);
          this.dialogRef.close();
          this.dialog.open(ConfirmationComponent, { panelClass: ['modal', 'edel-Confirmation'], width: '40vw', data: confirmResponse });
          this.eDeliveryService.retrievePreferences();
          // this.eDeliveryService.triggerLoadingIcon(true);
        }
        this.updatePreferencesInProgressFlag = false;
      },
      error => {
        this.updatePreferencesInProgressFlag = false;
        this.setError(error);
      });
  }

  setError(errorMessage: string, errorCode?: string): void {
    this._error.next(new PershingError(errorMessage, 'combinedSubscription', errorCode));
  }

}
